// composables/useTypography.ts
export const useTypography = () => {
  const fixCzechTypography = (text: string | undefined | null): string => {
    if (!text) return '';

    // Pravidlo pro jednopísmenné předložky:
    // Hledá (začátek řádku nebo bílý znak) + (předložka) + (mezera)
    // Nahrazuje za (předložka) + (nedělitelná mezera \u00A0)
    return text.replace(
      /(^|[\s\u00A0])([vzouskaipVZOUSKAIP])[\s\u00A0]+/g,
      '$1$2\u00A0'
    );
  };

  return {
    fixCzechTypography
  };
};
